import React from 'react';
import Radio from '../../../CommonComponents/Radio/Radio';

const ProductDetails = props => {
  const { orderDetails, currentItemData, dataLocale, match } = props;
  const { PRODUCT_DETAILS, SIZE, PID, ITEM_ID } = dataLocale;

  const onCheckRadio = id => {
    if (match?.params?.itemId !== id)
      window.location.pathname = `lens-package-upgrade/${match?.params?.orderId}/${id}`;
  };

  return (
    <div className="product-detail-wrapper margin-b16">
      <div className="title-wrapper fs16">{PRODUCT_DETAILS}</div>
      <div className="seperator"></div>
      {orderDetails?.result?.items?.map((item, index) => {
        return (
          <div key={'productDetails-' + index}>
            <div className="padding-l24 display-flex bg-white">
              <Radio
                checked={currentItemData.id + '' === item.id + ''}
                onClick={() => onCheckRadio(item.id)}
              />
              <div className="body-wrapper display-flex">
                <div className="margin-r30">
                  <img alt="productImage" className="img" src={item.image} />
                </div>
                <div className="margin-r30">
                  <div className="fs14 fw700">{item.name}</div>
                  <div className="fs12 fw400">
                    {item.lensType} | {SIZE}: {item.frameSize} {item.frameWidth}
                  </div>
                </div>
                <div className="margin-r30">
                  <div className="fs14 fw700">
                    {PID}: {item.productId}
                  </div>
                  <div className="fs12 fw400">
                    {ITEM_ID}: {item.id}
                  </div>
                </div>
              </div>
            </div>
            {index !== orderDetails?.result?.items?.length - 1 && <div className="seperator"></div>}
          </div>
        );
      })}
    </div>
  );
};

export default ProductDetails;
